import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStrikethroughBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconStrikethroughBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.53 3.53a.75.75 0 0 0-1.06-1.06l-1.946 1.945A3 3 0 0 0 17 4H7a3 3 0 0 0-3 3v10c0 .556.151 1.077.415 1.524L2.47 20.47a.75.75 0 1 0 1.06 1.06l1.946-1.945c.447.264.968.415 1.524.415h10a3 3 0 0 0 3-3V7c0-.556-.151-1.077-.415-1.524zm-4.142 2.02A1.5 1.5 0 0 0 17 5.5H7A1.5 1.5 0 0 0 5.5 7v10q.001.202.05.389zM6.612 18.45 18.45 6.61q.05.187.051.389v10a1.5 1.5 0 0 1-1.5 1.5H7q-.202-.001-.389-.05"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStrikethroughBox24);
